import { authApi } from './authApi';
import {
  User,
  CreateUserRequest,
  UpdateUserRequest,
  UserResponse,
} from '../types/user';

/**
 * Lista todos os usuários (Connect).
 * GET /users/
 */
export const getUsers = async (): Promise<UserResponse[]> => {
  const response = await authApi.get<UserResponse[]>('/users/');
  return response.data;
};

/**
 * Detalha um usuário (Connect).
 * GET /users/{id}/
 */
export const getUser = async (userId: string): Promise<UserResponse> => {
  const response = await authApi.get<UserResponse>(`/users/${userId}/`);
  return response.data;
};

/**
 * Cria novo usuário (Connect).
 * POST /users/
 */
export const createUser = async (
  userData: CreateUserRequest
): Promise<UserResponse> => {
  const response = await authApi.post<UserResponse>('/users/', userData);
  return response.data;
};

/**
 * Atualiza um usuário (Connect).
 * PUT /users/{id}/
 */
export const updateUser = async (
  userId: string,
  userData: UpdateUserRequest
): Promise<UserResponse> => {
  const response = await authApi.put<UserResponse>(`/users/${userId}/`, userData);
  return response.data;
};

/**
 * Deleta um usuário (Connect).
 * DELETE /users/{id}/
 */
export const deleteUser = async (userId: string): Promise<{ detail: string }> => {
  const response = await authApi.delete<{ detail: string }>(`/users/${userId}/`);
  return response.data;
};
